import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  .cardContainer{
    margin-top:15px;
  }
`;

export const GroupSection = styled.div`
  width: 100%;
  padding: 0 42px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  
  &.inputs {
    margin-top: 23px;
    margin-left: 180px;
    width:85%;    
    position: fixed;
    top: 0;
    z-index: 5;
    padding: 10px 42px 10px 42px;    

    .seletor-body {
      left: 0px;
      width: 100%;
    }
    
    .seletor-wrapper {
      background-color: ${(props) => props.theme.colors.groupInputsSeletorWrapperColor};
    }
  }

  &.cards {
    margin-top: -71px;
    padding: 0 16px;
  }

  .container {
    // produz 16px entre inputs
    max-width: ${(props) => `calc(${100 / props.totalItens}% - ${16 * (props.totalItens - 1) / props.totalItens}px)`};
    min-width: 220px;
    flex-grow: 1;

    &:last-of-type {
      margin-right: 0;
    }
  }

  button {
    .seletor-head {
      background-color: ${(props) => props.theme.colors.groupInputsSeletorWrapperColor};
      color: ${(props) => props.theme.colors.groupInputsSeletorWrapperColor};
    }

    .title {
      color: ${(props) => props.theme.colors.titleButtonSeletorHead};
    }
  }

  @media (max-width: 1600px) {
    &.inputs {
      width: 80%;
    }
  }
  @media (max-width: 1200px) {
    &.inputs {
      width:75%;
      .seletor-body {
        left: 0px;
        width: 100%;
      }
  }
  @media (max-width: 1080px) {
    &.inputs {      
      width:72%;
      .seletor-body {
        left: 0px;
        width: 100%;
      }
    }
    .container {
      width: 100%;
      min-width: initial;
      margin-bottom: 0px;
    }
  }
    @media (max-width: 930px) {
      &.inputs {        
        width:62%;
        .seletor-body {
          left: 0px;
          width: 100%;
        }
      }
  }
  @media (max-width: 930px) {
    &.inputs {        
      width:58%;
    }
}
  @media (max-width: 586px) {    
    &.inputs {
      display:inline-block;
      width:100%;
      margin-top: 55px;
      margin-left: -20px;
      padding-right: 5px;
      .seletor-body {
        left: 0px;
        width: 100%;
        margin-top: 49px;
        margin-left: -13px;
      }
    }
    
    .container {
      width: 100%;
      min-width: 100%;
      margin-bottom: 0px;
    }

    .seletor-wrapper {
      padding: 0 10px;
      margin: 5px 0px;
      display: inline-flex;
      align-items: center;
      heigth:35px;
      .seletor-head {
        height: 32px;

        .title {
          font-size: 1.2rem;
        }

        .chevrondown{
          font-size: 1.1rem;
        }
      }
    }

    .replace-selector-title {
      .title:after {
        visibility: visible;
        left: 5px;
        position: absolute;
      }
      .title {
        visibility: hidden;
      }
    }

    .replace-selector-title.seletor-cliente {
      .title:after {
        content: 'Cliente';
      }
    }

    .replace-selector-title.seletor-pesquisa {
      .title:after {
        content: 'Pesquisa';
      }
    }

    .replace-selector-title.seletor-pergunta {
      .title:after {
        content: 'Pergunta';
      }
    }
  }
`;

export const ThemeAware = styled.div`
  input {
     background: ${(props) => props.theme.colors.headerGroupInputsBackgroundColor};
  }

  .title.selected {
    color: ${(props) => props.theme.colors.headerGroupInputsColorWhenSelected} !important;
    // font-weight: 500 !important; //TODO: a pedido de edu
  }
`;
